export const CURRENT_TAX_EXPORT_YEAR = new Date().getFullYear();
export const TAX_EXPORT_YEAR_OPTIONS = Array.from(
  { length: 4 },
  (_, index) => CURRENT_TAX_EXPORT_YEAR - index,
);
export const TAX_EXPORT_SELECTED_YEAR_STORAGE_KEY = 'pinecurl.tax-export.selected-year';

export function getSafeTaxExportYear(value?: number | null): number {
  const numericValue = Number(value);
  return TAX_EXPORT_YEAR_OPTIONS.includes(numericValue)
    ? numericValue
    : CURRENT_TAX_EXPORT_YEAR;
}

export function readPersistedTaxExportYear(): number {
  if (typeof window === 'undefined') {
    return CURRENT_TAX_EXPORT_YEAR;
  }

  return getSafeTaxExportYear(
    Number(window.localStorage.getItem(TAX_EXPORT_SELECTED_YEAR_STORAGE_KEY)),
  );
}

export function persistTaxExportSelectedYear(year: number): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(
    TAX_EXPORT_SELECTED_YEAR_STORAGE_KEY,
    String(getSafeTaxExportYear(year)),
  );
}
